module.exports = __webpack_public_path__ + "static/img/f1.5bcdff0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/custom/f1.png
// module id = D9CF
// module chunks = 0